<template>
    <rkm-area title="Procedimentos">
        <template slot="trailing">
            <rkm-button
                @click="$refs.Modal.open()"
                :disabled="!cid"
                color="primary"
                small
                title="Adicionar"
            >
                <rkm-icon icon="plus" /> Incluir procedimento
            </rkm-button>
        </template>

        <rkm-table
            :fields="fields"
            :items="model"
            hide-filters
            hide-pagination
        >
            <template v-slot:cell(procedimento)="{ item }">
                {{ item.procedimentoSolicitado ? `${item.procedimentoSolicitado.codigo} - ${item.procedimentoSolicitado.nome}` : '' }}
            </template>

            <template v-slot:cell(dataSolicitacao)="{ item }">
                {{ formatDate(item.dataSolicitacao) }}
            </template>

            <template v-slot:cell(clinica)="{ item }">
                {{ nome(form.clinicas, item.clinicaId) }}
            </template>

            <template v-slot:cell(caraterInternacao)="{ item }">
                {{ nome(form.caratersInternacao, item.caraterInternacaoId) }}
            </template>

            <template v-slot:cell(actions)="{ index, item }">
                <rkm-button
                    @click="$refs.Modal.open(item, index)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click="destroy(index)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            :additionals="additionals"
            :cid="cid"
            :form="form"
            :procedimentos="model"
            ref="Modal"
        />
    </rkm-area>
</template>

<script>
import Modal from './Modal'

import moment from 'moment'

export default {
    components: { Modal },
    data: () => ({
        fields: [
            { key: 'procedimento', label: 'Procedimento' },
            { class: 'col-min', key: 'dataSolicitacao', label: 'Data da solicitação' },
            { key: 'clinica', label: 'Clínica' },
            { key: 'caraterInternacao', label: 'Caráter de internação' },
            { class: 'col-min text-center', key: 'actions', label: 'Ações' },
        ],
    }),
    methods: {
        nome(opcoes, id) {

            return (opcoes ?? []).find(opcao => opcao.id === id)?.nome ?? ''
        },
        formatDate(data) {

            const dataFormatada = moment(data)

            return data && dataFormatada.isValid() ? dataFormatada.format('DD/MM/YYYY') : ''
        },
        destroy(index) {

            this.showDeleteConfirmation('Deseja realmente excluir o procedimento?', async () => {

                this.model.splice(index, 1)
            })
        },
    },
    props: {
        additionals: { type: Object, required: true },
        cid: { type: Object },
        form: { type: Object, required: true },
        model: { type: Array, required: true },
    }
}
</script>
